import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useQuoteContext } from '../../shared/contexts/QuoteContext';
import InfoIcon from '../../assets/images/icons/infoIcon.svg';
import { colours } from '../../shared/colors';

const FeeBreakdownTable = () => {
	const { feeBreakdownRows, isReferred, isDeclined } = useQuoteContext();

	const feeBreakdownColumns: GridColDef[] = [
		{
			field: 'package',
			headerName: 'Package',
			width: 200,
			sortable: false,
			align: 'left',
		},
		{
			field: 'basePremium',
			headerName: 'Base premium',
			headerAlign: 'center',
			sortable: false,
			align: 'right',
		},
		{
			field: 'gst',
			headerName: 'GST',
			headerAlign: 'center',
			sortable: false,
			align: 'right',
		},
		{
			field: 'stampDuty',
			headerName: 'Stamp duty',
			headerAlign: 'center',
			sortable: false,
			align: 'right',
		},
		{
			field: 'adminFee',
			headerName: 'Admin fee',
			headerAlign: 'center',
			sortable: false,
			align: 'right',
		},
		{
			field: 'adminFeeGST',
			headerName: 'Admin fee GST',
			headerAlign: 'center',
			sortable: false,
			align: 'right',
		},
		{
			field: 'totalPremium',
			headerName: 'Total premium',
			headerAlign: 'center',
			align: 'right',
			sortable: false,
			width: 140,
			renderHeader: (params) => (
				<div style={{ textAlign: 'center', width: '100%' }}>
					<span style={{ paddingRight: '0.5em' }}>{params.colDef.headerName}</span>
					<Tooltip title='Total premium includes Commission and GST.' placement='right'>
						<InfoOutlinedIcon
							sx={{
								fontSize: '1em',
								color: colours.primaryDark.main,
							}}
						/>
					</Tooltip>
				</div>
			),
		},
	];

	return (
		<TableContainer
			sx={{
				border: '1px solid rgba(224, 224, 224, 1)',
				borderRadius: '4px',
				my: '1em',
			}}
		>
			<Table>
				<TableHead
					sx={{
						backgroundColor: '#f9f9f9',
					}}
				>
					<TableRow
						sx={{ '& .MuiTableCell-root': { fontWeight: 700, fontSize: '12px' } }}
					>
						{feeBreakdownColumns.map((column, index) => (
							<TableCell
								key={`fee-breakdown-column-${column.field}`}
								width={index === 0 ? '25%' : '12.5%'}
								align={column.headerAlign}
								sx={{
									py: '0.5em',
								}}
							>
								{column.field === 'totalPremium' ? (
									<div style={{ textAlign: 'center', width: '100%' }}>
										<span style={{ paddingRight: '0.5em' }}>
											{column.headerName?.toUpperCase()}
										</span>
										<Tooltip
											title='Total premium includes Commission and GST.'
											placement='right'
										>
											<InfoOutlinedIcon
												sx={{
													fontSize: '1em',
													color: colours.primaryDark.main,
												}}
											/>
										</Tooltip>
									</div>
								) : (
									column.headerName?.toUpperCase()
								)}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{feeBreakdownRows.map((row, index) => {
						const rowData = Object.keys(row).filter((key) => key !== 'id');
						// console.log("KEYS", rowData);
						return (
							<TableRow
								key={`fee-breakdown-row-${row.id}`}
								sx={{
									'& .MuiTableCell-body': {
										fontWeight: 400,
										fontSize: '14px',
									},
								}}
								hover
							>
								{rowData.map((key, i) => {
									const [_, value] = Object.entries(row).find(
										(item) => item[0] === key
									) ?? ['', 0];

									return (
										<TableCell
											key={`cell-${key}-${i}`}
											align={i === 0 ? 'left' : 'right'}
										>
											{isReferred && key !== 'package'
												? 'Referred'
												: isDeclined && key !== 'package'
												? 'Declined'
												: value}
										</TableCell>
									);
								})}
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default FeeBreakdownTable;
